import React from "react";
import { clientLogos } from "../mock";

const Marquee = () => {
  const items = [...clientLogos, ...clientLogos];
  return (
    <section className="py-10 border-y border-[color:var(--icg-line)]">
      <div className="icg-marquee">
        <div className="icg-marquee__track">
          {items.map((name, i) => (
            <div
              key={i}
              className="flex items-center gap-3 shrink-0 whitespace-nowrap"
            >
              <span className="font-display text-2xl md:text-3xl font-medium tracking-tight text-[color:var(--icg-ink)]">
                {name}
              </span>
              <span className="h-1.5 w-1.5 rounded-full bg-[color:var(--icg-accent)]" />
            </div>
          ))}
        </div>
        <div className="icg-marquee__track" aria-hidden="true">
          {items.map((name, i) => (
            <div
              key={`b-${i}`}
              className="flex items-center gap-3 shrink-0 whitespace-nowrap"
            >
              <span className="font-display text-2xl md:text-3xl font-medium tracking-tight text-[color:var(--icg-ink)]">
                {name}
              </span>
              <span className="h-1.5 w-1.5 rounded-full bg-[color:var(--icg-accent)]" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Marquee;
